import { PropsWithChildren } from "react";
import { PropsWithClassName } from "@/shared/types/utils";
import { cn } from "@/shared/utils";

export const Title = (props: PropsWithClassName<PropsWithChildren>) => (
  <h2
    className={cn(
      props.className,
      "text-[32px] leading-9.5 font-semibold lg:text-[48px] lg:leading-14.5"
    )}
  >
    {props.children}
  </h2>
);
